module.exports = __webpack_public_path__ + "fonts/subset-mBank-SemiBoldItalic.797e7cca.woff2";